<script setup>
const props = defineProps({
  text: Object,
});
</script>

<template> 
  <section class="l-container p-section">
      <div class="max-w-content text-3xl lg:text-[5rem] !leading-[1.5]" v-html="text?.content"></div>
  </section>
</template>

<style></style>
